import { Button, CircularProgress } from "@mui/material";
import { useState, useContext } from "react";
import { useCart } from "react-use-cart";
import NotificationBar from "./NotificationBar";
import { AuthContext } from "../AuthContext";
import { useTranslation } from "react-i18next";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

const AddToCart = ({
    variant = "contained",
    className,
    quantity = 1,
    product,
    showNotification = true
}) => {
    const { t } = useTranslation();
    const { setCartId } = useContext(AuthContext);
    const { addItem } = useCart();

    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(false);
    const [outOfStock, setOutOfStock] = useState(false);

    const handleClick = (e, product) => {
        e.stopPropagation();

        console.log("META PRODUCT OBJECT:", product);

        const data = {
            id: product.id,
            name: product.name,
            name_ar: product.name_ar || product.name,
            name_ur: product.name_ur || product.name,
            stocks: product.stocks,
            price: product.discount_price ?? product.price,
            tax: product.tax || 0,
            quantity: quantity,
            img:
                Array.isArray(product.images) && product.images.length > 0
                    ? product.images[0]
                    : ""
        };

        setLoading(true);

        if (product.stocks !== 0) {
            addItem(data, quantity);

            // Meta Pixel — AddToCart event
            if (typeof window !== "undefined" && window.fbq) {
                window.fbq("track", "AddToCart", {
                    content_ids: [String(product.code)],
                    content_name: product.name,
                    content_type: "product",
                    currency: "AED",
                    value:
                        Number(product.discount_price ?? product.price) *
                        quantity,
                    contents: [
                        {
                            id: String(product.code),
                            quantity: quantity,
                            item_price: Number(
                                product.discount_price ?? product.price
                            ),
                        },
                    ],
                });
            }

            // TikTok Pixel — AddToCart event
            if (typeof window !== "undefined" && window.ttq) {
                window.ttq.track("AddToCart", {
                    content_id: String(product.id),
                    content_name: product.name,
                    currency: "AED",
                    value: product.discount_price ?? product.price,
                    quantity: quantity,
                });
            }

            setMessage(t("cart.product_added"));

            if (showNotification) {
                setOpen(true);
            }

            setLoading(false);
        } else if (product.stocks === 0) {
            setOutOfStock(true);
            setLoading(false);
            setMessage(t("cart.out_of_stock"));
            setOpen(true);
            return;
        }
    };

    return (
        <>
            <Button
                sx={{
                    flex: 1,
                    background: "#2858a3",
                    borderRadius: "999px",
                    textTransform: "capitalize",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    py: {
                        xs: "8px",
                        sm: "7px",
                        md: "8px"
                    },
                    fontSize: {
                        xs: "0.78rem",
                        sm: "0.75rem",
                        md: "0.88rem",
                        lg: "1rem"
                    },
                    boxShadow: "none",
                    "&:hover": {
                        background: "#000000",
                        boxShadow: "none"
                    },
                    "&.Mui-disabled": {
                        background: "#e0e0e0"
                    },
                    transition: "background 0.2s"
                }}
                variant={variant}
                className={className}
                onClick={(e) => handleClick(e, product)}
            >
                {loading && (
                    <CircularProgress
                        size={25}
                        className="text-white"
                    />
                )}

                {!loading && t("cart.add_to_cart")}

                <ShoppingCartOutlinedIcon className="ml-2 mt-2" />
            </Button>

            <NotificationBar
                open={open}
                setOpen={setOpen}
                type={outOfStock ? "error" : "success"}
                message={message}
            />
        </>
    );
};

export default AddToCart;



